import React from "react";
import Truck_Icon from "./images/Truck_Icon_4_2_edited.png";

export const CDKIntegrationPackageDisplay = () => {
  return (
    <div className="card-perspective-hover-container">
      <div
        className="paper-card-heavy d-md-flex my-3 card-perspective-hover"
        style={{ borderRadius: ".5rem", overflow: "hidden" }}
      >
        <div
          style={
            {
              // width: "120px",
            }
          }
          className="bg-dil-blue"
        >
          <img src={Truck_Icon} className="cdk-integration-package-image" />
        </div>
        <div className="p-1 px-3">
          <div className="font-600">Diligent Delivery Systems</div>
          <div>CDK Integration</div>
        </div>
      </div>
    </div>
  );
};
